import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import LogoBiblioteca from './../images/logo-biblioteca-teresiana.svg';
import LogoServizi from './../images/logo-servizi-bibliotecari-nero.png';

/*
 * Customization with image
 *
 * If you have a jpg/png, do like this:
 *
 * <figure className="icon">
 *  <img src={logo} alt="" />
 * </figure>
 *
 * Note the icon class.
 */

const messages = defineMessages({
  logo: {
    id: 'logo',
    defaultMessage: 'ASTER Mantova logo',
  },
  logo_biblioteca: {
    id: 'logo_biblioteca',
    defaultMessage: 'Servizi bibliotecari',
  },
});

const Logo = () => {
  const intl = useIntl();
  return (
    <>
      <img
        src={LogoBiblioteca}
        alt={intl.formatMessage(messages.logo)}
        width="70"
        height="70"
      />{' '}
      <img
        src={LogoServizi}
        alt={intl.formatMessage(messages.logo_biblioteca)}
        width="137"
        height="70"
      />
    </>
  );
};

export default Logo;
